import React from 'react';
import * as Icon from "ubs-icons";
import {COLOR} from "ubs-framework/v2/common/constant";

const UploadFile = React.memo((props) => {
    return (
        <React.Fragment>
            <div
                className={`u_org-dashboard u_px-20 u_pb-20`}
                id={'import-module'} onDragEnter={(e) => props?.onDragEnter(e)}
                onDragLeave={(e) => props?.dragLeave(e)}
                onDrop={(e) => e.preventDefault()}
                onDragOver={(e) => e.preventDefault()}>
                <div
                    className={`u_upload-file u_p-15 u_flex u_align-center u_content-center u_t-center u_flex-col`} {...props?.getRootProps({onClick: e => e.stopPropagation()})}>
                    {props?.file && !props?.loader ? <div
                            className="u_upload-file-inner u_flex u_align-center u_content-center u_t-center u_flex-col">
                            <Icon.XLS size={56} fill={COLOR.u_blue}/>
                        </div> :
                        props?.loader ?
                            <div
                                className="u_upload-file-inner u_flex u_align-center u_content-center u_t-center u_flex-col">
                                <Icon.Preloader/>
                                <p className="u_mt-15 u_one-line">Uploading File please wait..</p>
                            </div>
                            :
                            <div
                                className="u_upload-file-inner u_flex u_align-center u_content-center u_t-center u_flex-col">
                                <Icon.Upload size={56} fill={COLOR.u_blue}/>
                                <p className="u_mt-15">Drag & Drop File Here</p>
                                <p className="u_mt-15 u_mb-15">OR</p>
                                <label className="u_relative u_block u_cp">Browse File
                                    <input type="file" className="img_file_input" {...props?.getInputProps()}
                                           autoComplete="off"/>
                                </label>
                            </div>}
                    {props?.file && !props?.loader && <div className="u_choose-input u_choose-input-lable u_mt-15">
                        <div className="u_upload-file-inner">
                            <label className="u_relative u_block u_cp">Browse File
                                <input type="file" className="img_file_input" id="u_upload" {...props?.getInputProps()}
                                       accept='.xlsx, .xls' autoComplete="off"/>
                            </label>
                        </div>
                    </div>}
                </div>
            </div>
        </React.Fragment>
    );
});

export default UploadFile;
